import { httpGet, httpUrl } from "../../api/httpClient";
import { reactLocalStorage } from "reactjs-localstorage";

export const slimCoinList = (list) => {
  if (!Array.isArray(list)) return [];
  return list.map((c) => ({
    coinType: Number(c.coinType),
    decimal: Number(c.decimal),
    name: c.name,
    symbol: c.symbol,
    category: c.category,
  }));
};

export const loadCoinList = async () => {
  const res = await httpGet(httpUrl.getBlockchainList, [], {});
  const list = slimCoinList(res && res.data);
  reactLocalStorage.setObject("coinList", list);
  return list;
};
